module.exports = __webpack_public_path__ + "static/media/ticket-ret.ecda7a05.svg";